import clsx from "clsx";
import { money } from "@/shared/lib/format";

/** An amount in tabular figures with the currency as a quiet suffix. */
export function Money({ value, currency, className, strong }: { value?: string | number | null; currency?: string; className?: string; strong?: boolean }) {
  return (
    <span className={clsx("num whitespace-nowrap", strong && "font-semibold", className)}>
      {money(value, currency)}
      {currency && <span className="ms-1 text-[11px] font-normal text-ink-3">{currency}</span>}
    </span>
  );
}
